import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import React from "react";
import { Outlet, useParams, useRoute } from "@bcm-dev/bcms-vite";
import "./styles.css";

/**
 * @function SetPinPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SetPinPage
 */
export default function SetPinPage(props) {
  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  return(
    <MainContentContainer 
      className="set-pin-page" 
      header={
        <MainContentHeader text="Set PIN" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } />
      }>
      
      <Outlet />
    </MainContentContainer>
  );
}